// @flow

export const MODAL_BLUR_ON = 'MODAL_BLUR_ON';
export const MODAL_BLUR_OFF = 'MODAL_BLUR_OFF';
export const HAMBURGER_MENU_OPEN = 'HAMBURGER_MENU_OPEN';
export const HAMBURGER_MENU_CLOSE = 'HAMBURGER_MENU_CLOSE';
export const PROFILE_MENU_OPEN = 'PROFILE_MENU_OPEN';
export const PROFILE_MENU_CLOSE = 'PROFILE_MENU_CLOSE';
export const MEMBERSHIP_MODAL_OPEN = 'MEMBERSHIP_MODAL_OPEN';
export const MEMBERSHIP_MODAL_COPY = 'MEMBERSHIP_MODAL_COPY';
export const MEMBERSHIP_MODAL_CLOSE = 'MEMBERSHIP_MODAL_CLOSE';
export const PLANNED_DOWNTIME_MODAL_OPEN = 'PLANNED_DOWNTIME_MODAL_OPEN';
export const PLANNED_DOWNTIME_MODAL_CLOSE = 'PLANNED_DOWNTIME_MODAL_CLOSE';
export const NETWORK_ERROR_MODAL_OPEN = 'NETWORK_ERROR_MODAL_OPEN';
export const NETWORK_ERROR_MODAL_CLOSE = 'NETWORK_ERROR_MODAL_CLOSE';
export const SERVER_ERROR_MODAL_OPEN = 'SERVER_ERROR_MODAL_OPEN';
export const SERVER_ERROR_MODAL_CLOSE = 'SERVER_ERROR_MODAL_CLOSE';
export const NAV_BAR_SHOW = 'NAV_BAR_SHOW';
export const NAV_BAR_HIDE = 'NAV_BAR_HIDE';
export const WORKS_TAB_RESET = 'WORKS_TAB_RESET';
export const WORKS_TAB_SHAREHOLDERS_OPEN = 'WORKS_TAB_SHAREHOLDERS_OPEN';
export const WORKS_TAB_MORE_INFO_OPEN = 'WORKS_TAB_MORE_INFO_OPEN';
export const BACKGROUND_BLUR_ON = 'BACKGROUND_BLUR_ON';
export const BACKGROUND_BLUR_OFF = 'BACKGROUND_BLUR_OFF';

const BACKGROUND_BLUR_DELAY_MS = 450;

const hamburgerMenuOpen = () => ({ type: HAMBURGER_MENU_OPEN });

const hamburgerMenuClose = () => ({ type: HAMBURGER_MENU_CLOSE });

const profileMenuOpen = () => ({ type: PROFILE_MENU_OPEN });

const profileMenuClose = () => ({ type: PROFILE_MENU_CLOSE });

const membershipModalOpen = () => ({ type: MEMBERSHIP_MODAL_OPEN });

const membershipNumberCopy = () => ({ type: MEMBERSHIP_MODAL_COPY });

const membershipModalClose = () => ({ type: MEMBERSHIP_MODAL_CLOSE });

export const networkErrorModalOpen = retryFunction => ({
  type: NETWORK_ERROR_MODAL_OPEN,
  retryFunction,
});

export const serverErrorModalOpen = retryFunction => ({
  type: SERVER_ERROR_MODAL_OPEN,
  retryFunction,
});

export const networkErrorModalClose = () => ({ type: NETWORK_ERROR_MODAL_CLOSE });

export const serverErrorModalClose = () => ({ type: SERVER_ERROR_MODAL_CLOSE });

export const showNavBar = () => ({ type: NAV_BAR_SHOW });

export const hideNavBar = () => ({ type: NAV_BAR_HIDE });

const worksTabShareholdersOpen = () => ({ type: WORKS_TAB_SHAREHOLDERS_OPEN });

const worksTabMoreInfoOpen = () => ({ type: WORKS_TAB_MORE_INFO_OPEN });

const worksTabReset = () => ({ type: WORKS_TAB_RESET });

let blurBackgroundTimeout = null;

function handleBackgroundBlur(dispatch, getState) {
  const { ui } = getState();
  clearTimeout(blurBackgroundTimeout);
  if (
    ui.showProfileMenu ||
    ui.membershipModalIsOpen ||
    ui.plannedDowntimeModalIsOpen ||
    ui.networkErrorModalIsOpen
  ) {
    blurBackgroundTimeout = setTimeout(() => dispatch({ type: BACKGROUND_BLUR_ON }),
      BACKGROUND_BLUR_DELAY_MS);
  } else {
    dispatch({ type: BACKGROUND_BLUR_OFF });
  }
}

export const openPlannedDowntimeModal = () => (dispatch, getState) => {
  dispatch({ type: PLANNED_DOWNTIME_MODAL_OPEN });
  handleBackgroundBlur(dispatch, getState);
};

export const closePlannedDowntimeModal = () => (dispatch, getState) => {
  dispatch({ type: PLANNED_DOWNTIME_MODAL_CLOSE });
  handleBackgroundBlur(dispatch, getState);
};

export const openMembershipModal = () => (dispatch, getState) => {
  dispatch(membershipModalOpen());
  handleBackgroundBlur(dispatch, getState);
};

export const copyMembershipNumber = () => (dispatch) => {
  dispatch(membershipNumberCopy());
};

export const closeMembershipModal = () => (dispatch, getState) => {
  dispatch(membershipModalClose());
  handleBackgroundBlur(dispatch, getState);
};

export const openHamburgerMenu = () => (dispatch, getState) => {
  const state = getState();
  if (state.ui.showProfileMenu) {
    dispatch(profileMenuClose());
    setTimeout(() => dispatch(hamburgerMenuOpen()), 340);
  } else {
    dispatch(hamburgerMenuOpen());
  }
};

export const closeHamburgerMenu = () => (dispatch) => {
  dispatch(hamburgerMenuClose());
};

export const openProfileMenu = () => (dispatch, getState) => {
  const state = getState();
  if (state.ui.showMainMenu) {
    dispatch(hamburgerMenuClose());
    setTimeout(() => {
      dispatch(profileMenuOpen());
      handleBackgroundBlur(dispatch);
    }, 320);
  } else {
    dispatch(profileMenuOpen());
    handleBackgroundBlur(dispatch, getState);
  }
};

export const closeProfileMenu = () => (dispatch, getState) => {
  dispatch(profileMenuClose());
  handleBackgroundBlur(dispatch, getState);
};

export const openWorksShareholdersTab = () => (dispatch) => {
  dispatch(worksTabShareholdersOpen());
};

export const openWorksMoreInfoTab = () => (dispatch) => {
  dispatch(worksTabMoreInfoOpen());
};

export const resetWorkTabs = () => (dispatch) => {
  dispatch(worksTabReset());
};

export const showNetworkErrorModal = () => (dispatch, getState) => {
  dispatch(networkErrorModalOpen());
  handleBackgroundBlur(dispatch, getState);
};

export const closeNetworkErrorModal = () => (dispatch, getState) => {
  dispatch(networkErrorModalClose());
  handleBackgroundBlur(dispatch, getState);
};

export const runRetryFunction = () => (dispatch, getState) => {
  const { retryFunction } = getState().ui;
  dispatch(networkErrorModalClose());
  retryFunction()(dispatch, getState);
};

export const handleNetworkError = (dispatch, error, retryFunction) => {
  if (navigator) {
    if (!navigator.onLine) {
      dispatch(networkErrorModalOpen(retryFunction));
    } else {
      dispatch(serverErrorModalOpen(retryFunction));
    }
  }
};


export const defaultState = {
  showModalBlur: false,
  showMainMenu: false,
  showProfileMenu: false,
  membershipModalIsOpen: false,
  plannedDowntimeModalIsOpen: false,
  networkErrorModalIsOpen: false,
  showNavBar: true,
  shareholdersTabOpen: true,
  moreTabOpen: false,
  isServerError: false,
  membershipNumberCopied: false,
  retryFunction: () => { },
};

const UiReducer = (state: Object = defaultState, action: Object = {}) => {
  switch (action.type) {
    case HAMBURGER_MENU_OPEN:
      return Object.assign({}, state, {
        showMainMenu: true,
      });
    case HAMBURGER_MENU_CLOSE:
      return Object.assign({}, state, {
        showMainMenu: false,
      });
    case PROFILE_MENU_OPEN:
      return Object.assign({}, state, {
        showProfileMenu: true,
      });
    case PROFILE_MENU_CLOSE:
      return Object.assign({}, state, {
        showProfileMenu: false,
      });
    case MEMBERSHIP_MODAL_OPEN:
      return Object.assign({}, state, {
        membershipModalIsOpen: true,
        membershipNumberCopied: false,
      });
    case MEMBERSHIP_MODAL_CLOSE:
      return Object.assign({}, state, {
        membershipModalIsOpen: false,
        membershipNumberCopied: false,
      });
    case MEMBERSHIP_MODAL_COPY:
      return Object.assign({}, state, {
        membershipModalIsOpen: true,
        membershipNumberCopied: true,
      });
    case PLANNED_DOWNTIME_MODAL_OPEN:
      return Object.assign({}, state, {
        plannedDowntimeModalIsOpen: true,
      });
    case PLANNED_DOWNTIME_MODAL_CLOSE:
      return Object.assign({}, state, {
        plannedDowntimeModalIsOpen: false,
      });
    case NETWORK_ERROR_MODAL_OPEN:
      return Object.assign({}, state, {
        networkErrorModalIsOpen: true,
        retryFunction: action.retryFunction,
      });
    case NETWORK_ERROR_MODAL_CLOSE:
      return Object.assign({}, state, {
        networkErrorModalIsOpen: false,
      });
    case SERVER_ERROR_MODAL_OPEN:
      return Object.assign({}, state, {
        networkErrorModalIsOpen: true,
        isServerError: true,
        retryFunction: action.retryFunction,
      });
    case SERVER_ERROR_MODAL_CLOSE:
      return Object.assign({}, state, {
        isServerError: false,
        networkErrorModalIsOpen: false,
      });
    case BACKGROUND_BLUR_ON:
      return Object.assign({}, state, {
        showModalBlur: true,
      });
    case BACKGROUND_BLUR_OFF:
      return Object.assign({}, state, {
        showModalBlur: false,
      });
    case NAV_BAR_SHOW:
      return Object.assign({}, state, {
        showNavBar: true,
      });
    case NAV_BAR_HIDE:
      return Object.assign({}, state, {
        showNavBar: false,
      });
    case WORKS_TAB_RESET:
    case WORKS_TAB_SHAREHOLDERS_OPEN:
      return Object.assign({}, state, {
        shareholdersTabOpen: true,
        moreTabOpen: false,
      });
    case WORKS_TAB_MORE_INFO_OPEN:
      return Object.assign({}, state, {
        shareholdersTabOpen: false,
        moreTabOpen: true,
      });
    default:
      return state;
  }
};

export default UiReducer;
